const linkDownload = {
  displayField: 'text',
  name: 'Download Link',
  description: '',
  fields: [
    {
      id: 'text',
      name: 'Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'downloadableAsset',
      name: 'DownloadableAsset',
      type: 'Link',
      localized: false,
      required: true,
      validations: [
        {
          linkMimetypeGroup: [ 'presentation', 'spreadsheet', 'pdfdocument' ]
        }
      ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    }
  ],
  sys: {
    id: 'linkDownload',
    version: 10,
    updatedAt: '2023-08-02T21:05:04.566Z'
  }
};
export default linkDownload;